<mat-toolbar color="primary">
  <span>{{ 'Churn Rate' | translate }}</span>
</mat-toolbar>
<div class="widgetChart">
  <canvas baseChart [data]="churnChartData" [options]="churnChartOptions" type="line"></canvas>
</div>
